import { post, get } from "./HttpClient"
import {
    API_LOGIN,
    API_SOCIAL_AUTH_SDK_VALIDATE,
    API_SOCIAL_AUTH_VALIDATE,
} from "./ApisRoutes"

export const LoginService = (params) => {
    // console.log(params);
    return new Promise((resolve, reject) => {
        post(API_LOGIN, params).then(response => {
            const _loginResponse = response?.data;
            // console.log(_loginResponse);
            resolve(_loginResponse);
        }).catch(error => {
            console.error("login response error", error);
            reject(error);
        });
    });
}

export const ValidateAuth = ({Provider, UserId}) => {
    return new Promise((resolve, reject) => {
        get(
            `${API_SOCIAL_AUTH_VALIDATE}?provider=${encodeURIComponent(
                Provider ?? ""
            )}&userId=${encodeURIComponent(UserId ?? "")}`
        )
            .then(response => {
                const _loginResponse = response?.data;
                resolve(_loginResponse);
            })
            .catch(error => {
                console.error("login response error", error);
                reject(error);
            });
    });
};

export const PostValidateAuth = payload => {
    return new Promise((resolve, reject) => {
        post(API_SOCIAL_AUTH_SDK_VALIDATE, payload)
            .then(response => {
                const _loginResponse = response?.data;
                resolve(_loginResponse);
            })
            .catch(error => {
                console.error("login response error", error);
                reject(error);
            });
    });
};
